import {APP_INITIALIZER, ApplicationConfig} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient} from "@angular/common/http";

import {
  HERO_APPLICATIONS,
  HERO_CUSTOMER,
  HERO_DEFAULT_LANGUAGE,
  HERO_DEFAULT_LOCATION,
  HERO_FLOW_SERVICE
} from "lib-hero";

import {
  BOOX_APIS,
  BOOX_DEFAULT_API,
  BOOX_SESSION,
  BooxBootService,
  BOOX_APPLICATION_HOST
} from "lib-boox";

import { customerEnvironment } from "../../../../environments/environment";
import { routes } from './app.routes';
import {BootService} from "./service/boot.service";

console.log('customerEnvironment', customerEnvironment);

export const appConfig: ApplicationConfig = {
  providers: [

    { provide: HERO_CUSTOMER, useValue: customerEnvironment.customer },
    { provide: HERO_APPLICATIONS, useValue: customerEnvironment.applications },
    { provide: HERO_DEFAULT_LOCATION, useValue: customerEnvironment.default_location},
    { provide: HERO_DEFAULT_LANGUAGE, useValue: customerEnvironment.default_language},
    { provide: HERO_FLOW_SERVICE, useValue: customerEnvironment.flow.service },

    { provide: BOOX_APIS, useValue: customerEnvironment.apis },
    { provide: BOOX_DEFAULT_API, useValue: 'host' },
    { provide: BOOX_SESSION, useValue: { ...customerEnvironment.session, storage_key: 'host-session' }},
    { provide: BOOX_APPLICATION_HOST, useValue: { name: 'HEROHost', call_sign: 'host', version: '0.0.1', description: 'Hero Host application' }},

    provideRouter(routes),
    provideHttpClient(),

    // Boot
    { provide: APP_INITIALIZER, useFactory: (boox: BooxBootService, host: BootService) => () => boox.load().then(() => host.load()), deps: [BooxBootService, BootService], multi: true },
  ]
};
